export const config = {
  domain: 'form.eu.auth0.com',
  clientId: 'Ky666rw6yzu51ZKypEq4SImqgI1kfbcd'
};
